import { Cell } from '@table-library/react-table-library/table';
import { showPlatform } from '../../../PromptManager/keys';
import { AI_TOOLS } from '../../../configs';
import DomainImage from '../../../../../components/DomainImage';
// Helper function to parse platforms string into array
const parsePlatforms = (platformsStr) => {
    return platformsStr ? platformsStr.split(',') : [];
};

// Helper function to get unique link types count
const getLinkTypesCount = (linkTypesStr) => {
    return linkTypesStr ? new Set(linkTypesStr.split(',')).size : 0;
};

export const COLUMNS = (t) => [
    {
        label: t('ai_tracking.keyword_detail.urls.columns.url'),
        key: 'url',
        data: 'url',
        Component: Cell,
        sortType: 'string',
        cellSize: 'minmax(250px, 2.5fr)',
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <strong className="wrap-text">
                    {item.title === 'None' ? getName(data) : item.title}{' '}
                    <a
                        target="_blank"
                        className="link-website d-inline-flex align-items-center justify-content-center"
                        href={data}
                        rel="noreferrer"
                    >
                        <i className="icon-external-link"></i>
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.domain'),
        key: 'domain',
        data: 'domain',
        Component: Cell,
        sortType: 'string',
        cellSize: 'minmax(220px, 2fr)',
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.domain;
            return (
                <div>
                    <strong className="wrap-text d-flex align-items-center">
                        <DomainImage domain_name={item.domain} className="domain_img" />
                        <span>{item.domain}</span>
                    </strong>
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.title'),
        key: 'title',
        data: 'title',
        Component: Cell,
        cellSize: 'minmax(220px, 2fr)',
        sortType: 'string',
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.uniqueTitles'),
        key: 'uniqueTitles',
        data: 'uniqueTitles',
        Component: Cell,
        sortType: 'number',
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.avgPosition'),
        key: 'avgPosition',
        data: 'avgPosition',
        Component: Cell,
        sortType: 'number',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return data ? data.toFixed(2) : '-';
        },
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.rankings'),
        key: 'rankings',
        data: 'rankings',
        Component: Cell,
        sortType: 'number',
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.urlScore'),
        key: 'urlScore',
        data: 'urlScore',
        Component: Cell,
        sortType: 'number',
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.platforms'),
        key: 'platforms',
        data: 'platforms',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="d-flex flex-wrap gap-4">
                    {parsePlatforms(data).map((platform) => (
                        <div
                            key={platform}
                            title={AI_TOOLS[platform]}
                            className="ai-tracking-platform-2 no-clickable"
                        >
                            {showPlatform(platform)}
                        </div>
                    ))}
                </div>
            );
        },
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.platformsCNT'),
        key: 'platformsCNT',
        data: 'platformsCNT',
        Component: Cell,
        sortType: 'number',
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.linkTypes'),
        key: 'link_types',
        data: 'link_types',
        Component: Cell,
        sortType: 'string',
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return getLinkTypesCount(data);
        },
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.totalRuns'),
        key: 'totalRuns',
        data: 'totalRuns',
        Component: Cell,
        sortType: 'number',
    },
    {
        label: t('ai_tracking.keyword_detail.urls.columns.totalScore'),
        key: 'totalScore',
        data: 'totalScore',
        Component: Cell,
        sortType: 'number',
    },
];

function getName(url) {
    try {
        let name = '';
        try {
            const parsedUrl = new URL(url);
            const parts = parsedUrl.pathname.split('/').filter(Boolean); // remove empty parts like ""
            name = parts.length ? parts[parts.length - 1] : '';
        } catch (error) {
            name = url;
        }

        if (!name) return '';

        name = name.replace(/\\u0026|&/g, '');
        name = name.replace(/\br\/([a-zA-Z0-9_]+)/g, '$1');
        name = name.replace(/\s+/g, ' ').trim();

        return name;
    } catch (error) {
        return url;
    }
}
